import React from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from 'react-redux';
import SearchBar from "../../../../../../components/search-bar";
import {findUsers} from "../../../../../../../actions/usersListActions";
import {enteredCollaboratorSearchValue} from "../../../../../../../actions/sharingDetailsActions";
import {getEnteredSearchValue} from "../../../../../../../actions/contactsGroupItemActions";

class LabelSearch extends React.Component {

	constructor(props){
		super(props);

		this.changeHandler = this.changeHandler.bind(this);
	}

	changeHandler(e){

		this.props.enteredSearchValue(e.target.value);

		if(this.props.usersListFilteredStatus){
            if(this.props.usersListFilteredLicense){
                this.props.setFindUsers(this.props.usersListFilteredStatus, this.props.usersListFilteredLicense)
            } else {
                this.props.setFindUsers(this.props.usersListFilteredStatus)
			}
		} else {
            if(this.props.usersListFilteredLicense){
                this.props.setFindUsers(null, this.props.usersListFilteredLicense)
            } else {
                this.props.setFindUsers()
			}
		}

	}

	render() {
		return (
            <SearchBar
	            id="searchLabelUserList"
	            label="Search a label"
	            title={this.props.t("textSearchLabel")}
	            srOnly={true}
                onChange={this.changeHandler}
                placeholder={this.props.t("textSearchLabel")}
                width={150}
            />
		)
	}
}

const mapStateToProps = (state) => {
    return {
        usersListFilteredStatus: state.usersListReducer.usersListFilteredStatus,
        usersListFilteredLicense: state.usersListReducer.usersListFilteredLicense
    };
};

const mapDispatchToProps = (dispatch) => {
	return {
		setFindUsers : (labelId, pageSize) => {
			dispatch(findUsers(labelId, pageSize))
		},
		enteredSearchValue  : (string) => {
			dispatch(getEnteredSearchValue(string))
		},
        enteredCollaboratorSearchValue  : (string) => {
            dispatch(enteredCollaboratorSearchValue(string))
        },
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LabelSearch));